export const FeatureFlagKeys = {
   ROLE_TEMPLATES: 'roleTemplates',
   HELP_SIDEBAR: 'helpSidebar',
   GOALS_DETAIL: 'goalsDetail',
   COMPETENCIES: 'competencies',
   PERMISSION_GROUPS: 'permissionGroups',
   MANAGER_NOTES: 'managerNotes',
};
